//@flow
import {useStores} from 'hooks/useStores';

export const useEventSource = (eventSource: string): void => {
  const {eventStore} = useStores();

  eventStore.setEventSource(eventSource);
};
